import React, { useState, useEffect } from "react";
import { fetchData } from "../../Components/common/utils";
import MainLoader from "../../Components/MainLoader";
import { useLocation } from "react-router-dom";
import BookingModal from "../../Components/BookingModal";
function BazzarProductDetail() {
    const [shopDetail, setShopDetail] = useState({});
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const fetchApiData = async () => {
            const name = location.pathname.split("/").filter(Boolean).pop();
            const url = "api/product/detail/" + name;
            const result = await fetchData(url);
            setLoading(false);
            if (result && result.data) {
                console.log(result.data)
                setShopDetail(result.data);
            }
        };
        fetchApiData();
    }, [location.pathname]);

    return (
        <div className="container py-5">
            {loading ? (
                <MainLoader />
            ) : (
                <>
                    <div className="">
                        {/* Modern Header */}
                        <div className="brand-banner py-5 px-3 text-center text-white mb-4">
                            <h1 className="display-4 fw-bold mb-2">Product <span className="brand-name">Detail</span> </h1>
                            <p className="lead">Find all the essential details to help you make the right choice.</p>
                        </div>
                    </div>
                    <div className="card p-4 border-0 shadow rounded-4">
                        <div className="row">
                            <div className="col-md-12 col-sm-12 col-12">
                                <div className="d-flex gap-2 flex-wrap">
                                    <h4 className="mb-3 text-primary">{shopDetail?.title}</h4>
                                </div>
                                <p>{shopDetail?.short_description}</p>

                            </div>
                            <div className="col-md-12 col-12 col-sm-12">
                                <img src={shopDetail.media[0]?.original_url} style={{ height: '16em', objectFit: 'contain' }} className="w-100" />
                            </div>
                        </div>


                        {/* Shop API Detail Section */}
                        <div className="mt-5">
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <div className="p-3 bg-light rounded border">
                                        <strong className="text-capitalize">Product Category:</strong>{" "}
                                        <span className="text-muted">{shopDetail?.category?.title}</span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="p-3 bg-light rounded border">
                                        <strong className="text-capitalize">Price:</strong>{" "}
                                        <span className="text-muted">{shopDetail?.price}</span>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-5">
                                    <div dangerouslySetInnerHTML={{ __html: shopDetail?.long_description }}></div>
                                </div>

                            </div>
                            <div className="mt-3 text-end">
                                <BookingModal ProductDetail={shopDetail} />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default BazzarProductDetail;
